export default "__VITE_ASSET__km5szC_1__"